import { EventMessage, IControllerSubscription } from '../controller-classes';
import { useEffect, useRef, useState } from 'react';

type SubscriptionFeature = IControllerSubscription;

export type UseSubscription = [EventMessage | null];
export const useSubscription = (controller: SubscriptionFeature | null, showEvent = false, subscriptions:[string, string][] = []): UseSubscription => {
	const [event, setEvent] = useState<EventMessage | null>(null);
	// eslint-disable-next-line no-empty-function, @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
	const addSubscription = useRef<((noun: string, verb: string) => void)>((_noun: string, _verb: string) => {});

	// Cleanup must be tied to THIS controller: a `[]`-deps cleanup closes over the first one, leaking on every instance swap (promoteDraft/repoint).
	useEffect(() => {
		if (!controller) return undefined;

		const subIds: Array<string> = [];
		addSubscription.current = (noun: string, verb: string) => {
			if (showEvent) console.info('useSubscription addSubscription:', noun, verb);
			const sId = controller.subscribe(noun, verb, setEvent);
			if (sId) subIds.push(sId);
		};

		subscriptions.forEach(([noun, verb]) => addSubscription.current(noun, verb));

		return () => {
			if (showEvent) console.info('useSubscription cleanup:', subIds.length);
			subIds.forEach((sub) => controller.unsubscribe(sub));
		};
	}, [controller]);

	useEffect(() => { if (showEvent && event) console.info('useSubscription event:', event); }, [event]);

	return [event];
};
